import algoliasearch from 'algoliasearch';
import instantsearch from 'instantsearch.js';
import { searchBox, stats, configure } from 'instantsearch.js/es/widgets';
// On utilise la pagination du module normal
import customPagination from './algolia/pagination';
// On modifie les hits et la liste de filtres
import customHits from './algolia/hits';
import customRefinementList from './algolia/refinementList';
import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

/** Les clés d'API nécessaires à Algolia */
let apiIdentifiant = getApiIdentifiant();
/** @type {JSON} Les filtres utilisés */
let filtres = getFiltres();
/** @type {Object} Les filtres au format Algolia */
let formattedFiltres = formatFiltres(filtres);
/** @type {Object} Les traductions */
let traductions = getTraductions();

const searchClient = algoliasearch(apiIdentifiant.appId, apiIdentifiant.apiId);
const search = instantsearch({
    indexName: getAlgoliaIndex(),
    searchClient,
    initialUiState: getInitialUiState(),
});

let widgetParameters = [
    configure({
        filters: formattedFiltres.length > 1 ? formattedFiltres.concat(" ", "AND marque_pro=1") : formattedFiltres.concat("marque_pro=1"),
    }),
    searchBox({
        container: '.barreRecherche',
        placeholder: traductions.searchPlaceholder,
        showSubmit: false,
        cssClasses: {
            form: 'barreRecherche-interne form-group',
            input: 'form-control form-control-lg',
        },
    }),
    customHits({
        container: document.querySelector('#algolia_result'),
        traductions: traductions,
        transformItems: (items) => transformItems(items),
    }),
    customPagination({
        container: document.querySelector('#pagination_produit'),
        scrollTo: document.querySelector('header'),
    }),
    stats({
        container: '.tematik_produits-compteur',
        templates: {
            text: `
                {{#hasNoResults}}${traductions.stats.none}{{/hasNoResults}}
                {{#hasOneResult}}${traductions.stats.one}{{/hasOneResult}}
                {{#hasManyResults}}{{#helpers.formatNumber}}{{nbHits}}{{/helpers.formatNumber}} ${traductions.stats.several}{{/hasManyResults}}
            `,
        },
    }),
    customRefinementList({
        container: document.querySelector('#content_gammes'),
        header: document.querySelector('#header_gammes'),
        filtres: filtres.gammes,
        attribute: 'gamme_produit',
    }),
    customRefinementList({
        container: document.querySelector('#content_marques'),
        header: document.querySelector('#header_marques'),
        filtres: filtres.marques,
        attribute: 'marque',
    }),
    customRefinementList({
        container: document.querySelector('#content_modeDeVie'),
        header: document.querySelector('#header_modeDeVie'),
        filtres: filtres.modesConsommation,
        attribute: 'mode_de_consommation',
    }),
];

search.addWidgets(widgetParameters);
search.start();

/**
 * Retourne les identifiant client APP et API Algolia.
 *
 * @return
 */
function getApiIdentifiant() {
    let algoliaAppId = $('.tematik_produits').data('algolia-app-id');
    let algoliaApiId = $('.tematik_produits').data('algolia-api-id');

    if (algoliaAppId.length === 0 || algoliaAppId.length === 0) return null;

    return {
        appId: algoliaAppId,
        apiId: algoliaApiId,
    };
}

/**
 * Retourne le nom de l'index concerné pour la recherche en fonction de la langue de la page.
 *
 * @return {string} Renvoie `produits_fr` ou `produits_en`
 */
function getAlgoliaIndex() {
    let langue = filtres.langue;

    if (langue === 'fr') {
        return 'produits_fr';
    }

    return 'produits_en';
}

function getInitialUiState() {
    let { searchInput, gamme, mode_consommation } = getSearchFiltres();
    let { marques } = getSearchFiltres();

    if (marques) {
        marques = marques.toUpperCase();
    } else {
        marques = '';
    }

    let index = getAlgoliaIndex();

    if (!searchInput && !gamme && !mode_consommation && !marques) {
        return { [index]: {} };
    }

    let state = {
        [index]: {
            query: searchInput,
            refinementList: {
                gamme_produit: gamme ? [gamme] : [],
                mode_de_consommation: mode_consommation
                    ? [mode_consommation]
                    : [],
                marque: marques ? [marques] : [],
            },
        },
    };

    return state;
}

/**
 * Transforme la propriété `code_article` avec `toLowerCase()`.
 *
 * @param items
 * @return
 */
function transformItems(items) {
    return items.map((item) => {
        let newItem = item;
        // on met le code article en minuscule pour l'url
        newItem.code_article = newItem.code_article ? newItem.code_article.toLowerCase() : "";
        newItem.code_article_uvc = newItem.code_article_uvc ? newItem.code_article_uvc.toLowerCase() : "";
        // Traitement url, image path...
        return newItem;
    });
}

/**
 * Retourne les filtres sélectionnés dans les paramètres de bloc sous forme d'objet.
 *
 * @return {Object} filtres
 */
function getFiltres() {
    return $('.tematik_produits').data('filtres');
}

/**
 * Retourne les filtres définis dans la barre de recherche du dashboard sous forme d'objet.
 *
 * @return {Object} searchFiltres
 */
function getSearchFiltres() {
    return $('.tematik_produits').data('search-filtres');
}

/**
 * Retourne les traductions nécessaires pour l'affichages du bloc.
 *
 * @return {Object}
 */
function getTraductions() {
    return $('.tematik_produits').data('traductions');
}

/**
 * Transforme les filtres sous la forme de query filters Algolia.
 *
 * @param filtresJSON
 * @return {string}
 */
function formatFiltres(filtresJSON) {
    let rawTab = [];
    let filtresGamme = formatFiltresByFacet(
        filtresJSON.gammes,
        'gamme_produit'
    );
    if (filtresGamme.length > 0) {
        rawTab.push(filtresGamme);
    }
    let filtresCategorie = formatFiltresByFacet(
        filtresJSON.categories,
        'categorie_produit'
    );
    if (filtresCategorie.length > 0) {
        rawTab.push(filtresCategorie);
    }
    let filtresMarque = formatFiltresByFacet(filtresJSON.marques, 'marque');
    if (filtresMarque.length > 0) {
        rawTab.push(filtresMarque);
    }
    let filtresModeConsommation = formatFiltresByFacet(
        filtresJSON.modesConsommation,
        'mode_de_consommation'
    );
    if (filtresModeConsommation.length > 0) {
        rawTab.push(filtresModeConsommation);
    }

    return rawTab.join(' AND ');
}

/**
 * Formate les filtres par attributs Algolia.
 *
 * @param filtresATraiter
 * @param facetName
 *
 * @return {string}
 */
function formatFiltresByFacet(filtresATraiter, facetName) {
    if (filtresATraiter.length === 0) {
        return '';
    }
    let algoliaFiltres = [];
    filtresATraiter.forEach((filtre, index) => {
        if (filtre.indexOf("'") >= 0) {
            let echap = '\\';
            let position = filtre.indexOf("'");
            filtre = [
                filtre.slice(0, position),
                echap,
                filtre.slice(position),
            ].join('');
        }
        if (filtre.indexOf(' ') >= 0) {
            algoliaFiltres.push(`${facetName.concat(':', "'" + filtre + "'")}`);
        } else {
            algoliaFiltres.push(facetName.concat(':', filtre));
        }
    });

    return algoliaFiltres.join(' OR ');
}

// script permettant d'ajouter un produit à la selection
let isLogged = $('.tematik_produits').data('logged');
let loginPath = $('.tematik_produits').data('path-login');
$(document).on('click', '.panier', function() {
    // permet de changer l'action si on est connécté ou pas
    if (isLogged) {
        fetch('/controller/markal/ajoutPanier/' + $(this).data('id'))
            .then((res) => res.json())
            .then((jsonData) => {
                // const backgroundColor
                if (jsonData.messageType === true) {
                    // on recupère le nombre de produit
                    let nbProduit = parseInt(
                        $('#panierCounter').attr('data-count')
                    );
                    // on incremente de 1
                    $('#panierCounter').attr('data-count', nbProduit + 1);
                }
                let message = $('.tematik_produits').data('code-3');
                if (jsonData.message !== undefined) {
                    message = $('.tematik_produits').data(jsonData.message);
                }
                Toastify({
                    text: message,
                    duration: 3000,
                    close: true,
                    style: {},
                    gravity: 'bottom', // `top` or `bottom`
                    position: 'center', // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    className:
                        jsonData.messageType === true ? 'success' : 'error',
                }).showToast();
            });
    } else {
        $('#modalConnexion').modal('show');
    }
});

//script permettant de telecharger le .zip
$(document).on('click', '.zip', function() {
    // permet de changer l'action si on est connecté ou pas
    if (isLogged) {
        fetch('/controller/markal/creationZip/' + $(this).data('id'))
            .then((jsonData) => {
                window.location = jsonData.url;
            }).then((res) => {
                // message de succes
            })
            .catch((error) => {
                // message d'erreur
            });
    } else {
        $('#modalConnexion').modal('show');
    }
});

//script permettant de telecharger la fiche technique
$(document).on('click', '.fiche', function() {
    // permet de reconstituer le nom d'une fiche technique
    let codeArticle = $(this).data('code') ? $(this).data('code') : null;
    let codeArticleUVC = $(this).data('code-uvc') ? $(this).data('code-uvc') : null;
    let gencode = $(this).data('gencode') ? $(this).data('gencode') : null;
    let langue = $('.tematik_produits').data('langue') ?  $('.tematik_produits').data('langue') : null;
    // permet de changer l'action si on est connecté ou pas
    if (isLogged) {
        // On appelle la méthode qui permet de verifier si on peut telecharger une fiche technique
        fetch('/controller/markal/telechargerFicheTechnique/' + gencode + '/' + codeArticleUVC + '/' + langue + '/' + codeArticle)
        .then((res) => res.json())
        .then((jsonData) => {
            // Si on peut télécharger alors on télécharge via l'url de téléchargement
            if (jsonData.messageType === true && jsonData.filePath) {
                // Cette route permet de telecharger via l'url
                window.location = '/controller/markal/download/' + jsonData.filePath;
            } else {
                // on affiche un message d'erreur
                Toastify({
                    text: jsonData.message,
                    duration: 3000,
                    close: true,
                    style: {},
                    gravity: 'bottom', // `top` or `bottom`
                    position: 'center', // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    className:
                        jsonData.messageType === true ? 'success' : 'error',
                }).showToast();
            }
        });
    } else {
        // on affiche la modal de restriction
        $('#modalConnexion').modal('show');
    }
});


//script permettant de telecharger la fiche technique
$(document).on('click', '.etiquette', function() {
    // permet de reconstituer le nom d'une fiche technique
    let codeArticle = $(this).data('code') ? $(this).data('code') : null;
    let codeArticleUVC = $(this).data('code-uvc') ? $(this).data('code-uvc') : null;
    let gencode = $(this).data('gencode') ? $(this).data('gencode') : null;
    let langue = $('.tematik_produits').data('langue') ?  $('.tematik_produits').data('langue') : null;
    // permet de changer l'action si on est connecté ou pas
    if (isLogged) {
        // On appelle la méthode qui permet de verifier si on peut telecharger une fiche technique
        fetch('/controller/markal/telechargerEtiquette/' + gencode + '/' + codeArticleUVC + '/' + langue + '/' + codeArticle)
        .then((res) => res.json())
        .then((jsonData) => {
            // Si on peut télécharger alors on télécharge via l'url de téléchargement
            if (jsonData.messageType === true && jsonData.filePath) {
                // Cette route permet de telecharger via l'url
                window.location = '/controller/markal/download/' + jsonData.filePath;
            } else {
                // on affiche un message d'erreur
                Toastify({
                    text: jsonData.message,
                    duration: 3000,
                    close: true,
                    style: {},
                    gravity: 'bottom', // `top` or `bottom`
                    position: 'center', // `left`, `center` or `right`
                    stopOnFocus: true, // Prevents dismissing of toast on hover
                    className:
                        jsonData.messageType === true ? 'success' : 'error',
                }).showToast();
            }
        });
    } else {
        // on affiche la modal de restriction
        $('#modalConnexion').modal('show');
    }
});
